import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import {
  Breadcrumbs, Typography,
} from '@material-ui/core';
import PageLayout from '../../PageLayout';
import DeviationForm from '../DeviationForm';

const NewDeviationPage = () => {
  const intl = useIntl();
  const title = intl.formatMessage({ id: 'deviation.title', defaultMessage: 'Desvíos' });
  const newDeviation = intl.formatMessage({ id: 'deviation.newDeviation', defaultMessage: 'Nuevo' });

  function NewDeviationPageBreadcrumbs() {
    return (
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link color="inherit" to="/deviations" style={{ textDecoration: 'none' }}>
          <Typography variant="caption" color="textPrimary" style={{ fontWeight: 400, fontSize: 11 }}>{title}</Typography>
        </Link>
        <Typography variant="caption" color="textPrimary" style={{ fontWeight: 700, fontSize: 11 }}><strong>{newDeviation}</strong></Typography>
      </Breadcrumbs>
    );
  }

  return (
    <PageLayout
      title={title}
      breadCrumbs={<NewDeviationPageBreadcrumbs />}
    >
      <DeviationForm />
    </PageLayout>
  );
};

export default NewDeviationPage;
